import { Carriers } from "./types";

export const getCarrier = (shippingMethod: string): Carriers => {
  const carrier = shippingMethod.toUpperCase().split(".");

  switch (carrier[0]) {
    case "DHL":
      return carrier[1] === "EXPRESS" ? Carriers.DHL_EXPRESS : Carriers.DHL;
    case "EPOST":
      return Carriers.RRDONNELLEY;
    case "CIRRO":
      return Carriers.CIRRO_ECOMMERCE;
    default:
      return Carriers[carrier[0]] || Carriers.OTHER;
  }
};
